import styled, {createGlobalStyle, keyframes} from 'styled-components';
import {AI_BRAND_COLOR_CYAN, AI_BRAND_COLOR_MAGENTA} from '../../../aiMessageGenerator/aiGeneratorButton/AIGeneratorButton.css';
import {dFlex, dFlexColumn, dFlexCenter, dFlexStartBetween, alignCenter} from '../../../../globalVariables/GlobalFlex';

export const askBeamStyles = createGlobalStyle`
    @property --ask-beam-angle {
        syntax: '<angle>';
        initial-value: 0deg;
        inherits: false;
    }
`;

const beamAnimation = keyframes`
    0% {
        --ask-beam-angle: 0deg;
        opacity: 1;
    }
    85% {
        opacity: 1;
    }
    100% {
        --ask-beam-angle: 360deg;
        opacity: 0;
    }
`;

export const card = styled.div`
    position: relative;
    ${dFlexColumn}
    margin-top: var(--space-sm);
    padding: var(--space-lg);
    border: 1px solid var(--color-border-subtle);
    border-radius: var(--border-radius-border-radius-2xl);
    background: var(--color-bg-base);
    box-shadow: 0 2px 6px -3px rgba(0, 0, 0, 0.28);
    flex-shrink: 0;

    &::after {
        content: '';
        position: absolute;
        inset: -1.5px;
        z-index: 2;
        pointer-events: none;
        border-radius: inherit;
        padding: 2px;
        background: conic-gradient(
            from var(--ask-beam-angle),
            transparent 0deg 300deg,
            ${AI_BRAND_COLOR_CYAN} 335deg,
            ${AI_BRAND_COLOR_MAGENTA} 352deg,
            transparent 360deg
        );
        -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        opacity: 0;
        animation: ${beamAnimation} 1.1s ease-out 1 forwards;
    }

    @media (prefers-reduced-motion: reduce) {
        &::after {
            animation: none;
        }
    }
`;

export const head = styled.div`
    ${dFlexStartBetween}
    gap: var(--space-md);
`;

export const question = styled.span`
    flex: 1;
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-bold);
    line-height: 1.35;
    color: var(--color-text-default);
    text-align: start;
`;

export const closeButton = styled.button`
    ${dFlex}
    flex-shrink: 0;
    padding: 2px;
    border: none;
    background: none;
    cursor: pointer;
    color: var(--color-text-subtle);
`;

export const optionsList = styled.div`
    ${dFlexColumn}
    margin-top: var(--space-md);
`;

export const option = styled.button`
    ${dFlex}
    ${alignCenter}
    gap: var(--space-md);
    width: 100%;
    box-sizing: border-box;
    padding: var(--space-lg) var(--space-sm);
    border: none;
    border-top: 1px solid var(--color-border-subtle);
    border-radius: var(--border-radius-border-radius-md, 8px);
    background: none;
    cursor: pointer;
    font-size: var(--font-size-body);
    line-height: 1.3;
    color: var(--color-text-default);
    text-align: start;
    transition: background 0.15s ease;

    &:hover:not(:disabled) {
        background: var(--color-bg-surface-hover);
    }

    &:disabled {
        cursor: default;
        opacity: 0.6;
    }
`;

export const optionNumber = styled.span`
    ${dFlexCenter}
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: var(--color-bg-surface-default);
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-bold);
    color: var(--color-text-subtle);
`;

export const optionLabel = styled.span`
    flex: 1;
`;

export const composeRow = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: var(--space-sm);
    margin-top: var(--space-xs);
    padding-top: var(--space-md);
    border-top: 1px solid var(--color-border-subtle);
`;

export const pencilIcon = styled.span`
    ${dFlex}
    flex-shrink: 0;
    color: var(--color-text-subtle);
`;

export const customInput = styled.input`
    flex: 1;
    padding: 0;
    border: none;
    background: none;
    font-size: var(--font-size-body);
    color: var(--color-text-default);
    text-align: start;

    &:focus {
        outline: none;
    }

    &::placeholder {
        color: var(--color-text-subtle);
    }
`;
